export { default } from './BlockAwardCard'